"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
const useResourceLink_1 = require("./useResourceLink");
/* const config = useAwesomeResourceConfig(resource); */
exports.AwesomeResourceCard = ({ marginBottom, resource, data, }) => {
    const link = useResourceLink_1.useResourceLink(data);
    return (react_1.default.createElement(reactstrap_1.Card, { className: react_2.classnames(marginBottom && 'mb-2', 'd-flex', 'shadow-sm') },
        react_1.default.createElement(react_if_1.When, { condition: !data },
            react_1.default.createElement(exports.AwesomeResourceCardNotFound, { resource: resource })),
        react_1.default.createElement(react_if_1.When, { condition: !!data },
            react_1.default.createElement(exports.AwesomeResourceCardHeader, { data: data }),
            react_1.default.createElement(exports.AwesomeResourceCardFooter, { link: link, resource: resource }))));
};
exports.AwesomeResourceCardFooter = ({ resource, link, }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true, className: "border-top text-muted px-2 py-1" },
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true },
            react_1.default.createElement(react_2.OsmosysLogo, { marginRight: 2 }),
            ' '),
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true },
            react_1.default.createElement("p", { className: "m-0 small" },
                react_1.default.createElement(react_2.OsmosysChangeCase, { type: "sentenceCase" }, resource))),
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true }),
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true },
            react_1.default.createElement(react_2.OsmosysButton, { to: link, osysName: "AwesomeResourceCardFooter.Link", osysIcon: "externalLink", osysStyle: "link", size: "sm", openInNewTab: true }))));
};
exports.AwesomeResourceCardNotFound = ({ resource, }) => (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true, padding: true },
    react_1.default.createElement("p", { className: "lead text-muted my-1 text-center w-100" },
        "No ",
        react_1.default.createElement(react_2.OsmosysChangeCase, { type: "noCase" }, resource))));
exports.AwesomeResourceCardHeader = ({ data, }) => (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true, padding: true },
    react_1.default.createElement("h4", { className: "my-2 word-wrap", style: { wordBreak: 'break-word' } }, data.displayName ||
        data.name ||
        data.fullName ||
        data.email ||
        data.version)));
//# sourceMappingURL=index.js.map